// extracted by mini-css-extract-plugin
module.exports = {"nounButton":"VoteStatusPill_nounButton__1VHQj","pass":"VoteStatusPill_pass__3EIR8","fail":"VoteStatusPill_fail__2wF4b","pending":"VoteStatusPill_pending__3d_z7"};